import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { Check, Clock, X } from 'lucide-react';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomstructureset';

export default function StructureSetApprovalStatus({
    status,
}: {
    status: DICOMApprovalStatus;
}) {
    const { palette } = useTheme();
    switch (status) {
        case DICOMApprovalStatus.APPROVED:
            return (
                <Tooltip title="Structure Set is Approved" enterDelay={1500}>
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <Check size="12px" color={palette.success.main} />
                        <Typography fontSize={11} color="text.secondary">
                            Approved
                        </Typography>
                    </Box>
                </Tooltip>
            );
        case DICOMApprovalStatus.REJECTED:
            return (
                <Tooltip title="Structure Set is Rejected" enterDelay={1500}>
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <X size="12px" color={palette.error.main} />
                        <Typography fontSize={11} color="text.secondary">
                            Rejected
                        </Typography>
                    </Box>
                </Tooltip>
            );
        case DICOMApprovalStatus.UNAPPROVED:
            return (
                <Tooltip title="Structure Set is Unapproved" enterDelay={1500}>
                    <Box display="flex" alignItems="center" gap={0.5}>
                        <Clock size="10px" color={palette.warning.main} />
                        <Typography fontSize={11} color="text.secondary">
                            Unapproved
                        </Typography>
                    </Box>
                </Tooltip>
            );
        default:
            return null;
    }
}
